<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="合同号" style="width: 250px" size="small" clearable></el-input>
        <el-input v-model="keyword2" placeholder="货号" style="width: 250px;margin-left: 5px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="客户" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="合同号" min-width="100" prop="hetonghao"></el-table-column>
          <el-table-column align="center" label="货号" min-width="100" prop="huohao"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="chanpinguige"></el-table-column>
          <el-table-column align="center" label="合同数量" min-width="100" prop="hetongshuliang"></el-table-column>
          <el-table-column align="center" label="组焊件" min-width="700" prop="gongxu">
            <template slot-scope="scope">
              <div style="border-bottom: 1px solid #000;padding: 10px;display: flex;white-space: nowrap;"
                v-for="(item,index) in scope.row.gongxuArr" :key="index">
                <span style="margin-right: 10px;">组焊件名称：{{item.zuhanjian}}</span>
                <span style="margin-right: 10px;">套用量：{{item.taoyongliang}}</span>
                <span style="margin-right: 10px;">单价：{{item.danjia}}</span>
                <span style="margin-right: 10px;">成控单价：{{item.chengkongdanjia}}</span>
                <span style="margin-right: 10px;">焊道长度：{{item.handao}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="客户" prop="kehu">
          <el-input v-model="editForm.kehu"></el-input>
        </el-form-item>
        <el-form-item label="合同号" prop="hetonghao">
          <el-input v-model="editForm.hetonghao"></el-input>
        </el-form-item>
        <el-form-item label="货号" prop="huohao">
          <el-input v-model="editForm.huohao"></el-input>
        </el-form-item>
        <el-form-item label="产品规格" prop="chanpinguige">
          <el-input v-model="editForm.chanpinguige"></el-input>
        </el-form-item>
        <el-form-item label="合同数量" prop="hetongshuliang">
          <el-input-number v-model="editForm.hetongshuliang" :precision="5" :step="0.01" :max="100000000"></el-input-number>
        </el-form-item>
        <div v-for="(item,index) in gongxuArr" :key="index" style="border-top: 1px solid #000;padding-top: 20px;">
          <el-form-item label="组焊件名称">
            <el-input v-model="gongxuArr[index].zuhanjian" style="width: 400px;"></el-input>
            <el-button type="danger" size="small" style="margin-left: 20px" @click="gongxuDel(index)">删除组焊件</el-button>
          </el-form-item>
          <el-form-item label="套用量">
            <el-input-number v-model="gongxuArr[index].taoyongliang" :precision="0" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
          <div style="display: flex;">
            <el-form-item label="单价">
              <el-input-number v-model="gongxuArr[index].danjia" :precision="5" :step="1" :max="100000000"></el-input-number>
            </el-form-item>
            <el-form-item label="程控单价">
              <el-input-number v-model="gongxuArr[index].chengkongdanjia" :precision="5" :step="1" :max="100000000"></el-input-number>
            </el-form-item>
          </div>
          <el-form-item label="焊道长度">
            <el-input-number v-model="gongxuArr[index].handao" :precision="5" :step="1" :max="100000000"></el-input-number>
          </el-form-item>
        </div>
        <div>
          <el-form-item label=" ">
            <el-button type="primary" size="small" style="margin-right: 10px" @click="gongxuAdd">新增组焊件</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    kehu: '',
    hetonghao: '',
    huohao: '',
    chanpinguige: '',
    hetongshuliang: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      gongxuArr: [
        {zuhanjian: '', taoyongliang: 0, danjia: 0, chengkongdanjia: 0, handao: 0}
      ],
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    gongxuAdd() {
      let obj = {zuhanjian: '', taoyongliang: 0, danjia: 0, chengkongdanjia: 0, handao: 0}
      this.gongxuArr.push(obj)
    },
    gongxuDel(index) {
      this.gongxuArr.splice(index,1)
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.search()
    },
    
    add() {
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/Ordermodel/hanjienewMbInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        if(this.editForm.gongxuArr) {
          this.gongxuArr = JSON.parse(this.editForm.gongxuArr)
        }else{
          this.gongxuArr = [
            {zuhanjian: '', taoyongliang: 0, danjia: 0, chengkongdanjia: 0, handao: 0}
          ]
        }
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/Ordermodel/hanjienewMbDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = this.editForm
          data.gongxuArr = JSON.stringify(this.gongxuArr)
          this.$request.post('/index.php/admin/Ordermodel/hanjienewMbSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      this.$request.post('/index.php/admin/Ordermodel/hanjienewMbList', data).then((res) => {
        this.list = res.data.data
        for(let i in this.list) {
          if(this.list[i].gongxuArr) {
            this.list[i].gongxuArr = JSON.parse(this.list[i].gongxuArr)
          }else{
            this.list[i].gongxuArr = []
          }
        }
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
